// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnswerFilterController from "./answer_filter_controller"
application.register("answer-filter", AnswerFilterController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BulkDeleteController from "./bulk_delete_controller"
application.register("bulk-delete", BulkDeleteController)

import CandidateEditModalController from "./candidate_edit_modal_controller"
application.register("candidate-edit-modal", CandidateEditModalController)

import CandidateModalController from "./candidate_modal_controller"
application.register("candidate-modal", CandidateModalController)

import CandidatePreviewFormController from "./candidate_preview_form_controller"
application.register("candidate-preview-form", CandidatePreviewFormController)

import CellHighlightController from "./cell_highlight_controller"
application.register("cell-highlight", CellHighlightController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ChoiceHighlightController from "./choice_highlight_controller"
application.register("choice-highlight", ChoiceHighlightController)

import ChoicesPasteController from "./choices_paste_controller"
application.register("choices-paste", ChoicesPasteController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommonQuestionModalController from "./common_question_modal_controller"
application.register("common-question-modal", CommonQuestionModalController)

import ConfirmLeaveController from "./confirm_leave_controller"
application.register("confirm-leave", ConfirmLeaveController)

import ConfirmedScheduleController from "./confirmed_schedule_controller"
application.register("confirmed-schedule", ConfirmedScheduleController)

import ContactInlineEditController from "./contact_inline_edit_controller"
application.register("contact-inline-edit", ContactInlineEditController)

import CopyToGlobalController from "./copy_to_global_controller"
application.register("copy-to-global", CopyToGlobalController)

import CustomerVenuesController from "./customer_venues_controller"
application.register("customer-venues", CustomerVenuesController)

import DatetimePickerController from "./datetime_picker_controller"
application.register("datetime-picker", DatetimePickerController)

import DayBeforeReminderDialogController from "./day_before_reminder_dialog_controller"
application.register("day-before-reminder-dialog", DayBeforeReminderDialogController)

import DebouncedSearchController from "./debounced_search_controller"
application.register("debounced-search", DebouncedSearchController)

import DeliveryFilterController from "./delivery_filter_controller"
application.register("delivery-filter", DeliveryFilterController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExcelPreviewController from "./excel_preview_controller"
application.register("excel-preview", ExcelPreviewController)

import FileSubmitController from "./file_submit_controller"
application.register("file-submit", FileSubmitController)

import GreetingTemplateModalController from "./greeting_template_modal_controller"
application.register("greeting-template-modal", GreetingTemplateModalController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoverTooltipController from "./hover_tooltip_controller"
application.register("hover-tooltip", HoverTooltipController)

import ImportModalController from "./import_modal_controller"
application.register("import-modal", ImportModalController)

import ImportPreviewModalController from "./import_preview_modal_controller"
application.register("import-preview-modal", ImportPreviewModalController)

import IndividualReportFormController from "./individual_report_form_controller"
application.register("individual-report-form", IndividualReportFormController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InvitationPreviewController from "./invitation_preview_controller"
application.register("invitation-preview", InvitationPreviewController)

import JudgmentConditionToggleController from "./judgment_condition_toggle_controller"
application.register("judgment-condition-toggle", JudgmentConditionToggleController)

import ListModeController from "./list_mode_controller"
application.register("list-mode", ListModeController)

import LoginAccountToggleController from "./login_account_toggle_controller"
application.register("login-account-toggle", LoginAccountToggleController)

import PaginatedCheckboxController from "./paginated_checkbox_controller"
application.register("paginated-checkbox", PaginatedCheckboxController)

import PdfOptionsDialogController from "./pdf_options_dialog_controller"
application.register("pdf-options-dialog", PdfOptionsDialogController)

import PlaceholderInsertController from "./placeholder_insert_controller"
application.register("placeholder-insert", PlaceholderInsertController)

import PreAssignmentAnswerFormController from "./pre_assignment_answer_form_controller"
application.register("pre-assignment-answer-form", PreAssignmentAnswerFormController)

import PreAssignmentQuestionFormController from "./pre_assignment_question_form_controller"
application.register("pre-assignment-question-form", PreAssignmentQuestionFormController)

import PreviewConfirmController from "./preview_confirm_controller"
application.register("preview-confirm", PreviewConfirmController)

import PreviewHighlightController from "./preview_highlight_controller"
application.register("preview-highlight", PreviewHighlightController)

import QuarterHourController from "./quarter_hour_controller"
application.register("quarter-hour", QuarterHourController)

import QuestionCommentController from "./question_comment_controller"
application.register("question-comment", QuestionCommentController)

import QuestionSelectController from "./question_select_controller"
application.register("question-select", QuestionSelectController)

import QuestionTypeToggleController from "./question_type_toggle_controller"
application.register("question-type-toggle", QuestionTypeToggleController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import RenameIndividualReportDialogController from "./rename_individual_report_dialog_controller"
application.register("rename-individual-report-dialog", RenameIndividualReportDialogController)

import RenameListDialogController from "./rename_list_dialog_controller"
application.register("rename-list-dialog", RenameListDialogController)

import RichPlaceholderEditorController from "./rich_placeholder_editor_controller"
application.register("rich-placeholder-editor", RichPlaceholderEditorController)

import ScriptPreviewModalController from "./script_preview_modal_controller"
application.register("script-preview-modal", ScriptPreviewModalController)

import SegmentTabsController from "./segment_tabs_controller"
application.register("segment-tabs", SegmentTabsController)

import SidebarSectionController from "./sidebar_section_controller"
application.register("sidebar-section", SidebarSectionController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableFormController from "./sortable_form_controller"
application.register("sortable-form", SortableFormController)

import SurveyMethodFieldsController from "./survey_method_fields_controller"
application.register("survey-method-fields", SurveyMethodFieldsController)

import TabSearchBridgeController from "./tab_search_bridge_controller"
application.register("tab-search-bridge", TabSearchBridgeController)

import TableFilterController from "./table_filter_controller"
application.register("table-filter", TableFilterController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TalkScriptGreetingEditorController from "./talk_script_greeting_editor_controller"
application.register("talk-script-greeting-editor", TalkScriptGreetingEditorController)

import TemplateImportModalController from "./template_import_modal_controller"
application.register("template-import-modal", TemplateImportModalController)

import TemplateSaveModalController from "./template_save_modal_controller"
application.register("template-save-modal", TemplateSaveModalController)

import TemplateSelectController from "./template_select_controller"
application.register("template-select", TemplateSelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import VenueHintController from "./venue_hint_controller"
application.register("venue-hint", VenueHintController)

import VenueSelectController from "./venue_select_controller"
application.register("venue-select", VenueSelectController)

import WorkspaceCandidatesController from "./workspace_candidates_controller"
application.register("workspace-candidates", WorkspaceCandidatesController)

import WorkspaceChannelController from "./workspace_channel_controller"
application.register("workspace-channel", WorkspaceChannelController)

import WorkspaceEntryController from "./workspace_entry_controller"
application.register("workspace-entry", WorkspaceEntryController)
